export const validationRules = {
  requiredNotAllowEmpty: (message: string) => (value: string | boolean) => {
    if (!value || (typeof value === 'string' && !value.trim())) {
      return message;
    }
    return true;
  },
};
